import React from 'react'
import { BrowserRouter, Switch } from 'react-router-dom'
import MobileDetect from 'mobile-detect'

import ScrollToTop from './common/components/scroll-to-top'
import withAuthentication from './common/components/with-authentication'
import { default as RoutesDesktop } from './routes-desktop'
import { default as RoutesMobile } from './routes-mobile'

import './common/styles/style.css'

const mobileDetector = new MobileDetect(window.navigator.userAgent)
let Routes = null

if (!mobileDetector.mobile()) {
	require('./desktop/styles/style.css')
	Routes = RoutesDesktop
} else {
	require('./mobile/styles/style.css')
	Routes = RoutesMobile
}

const App = () => {
	return (
		<BrowserRouter>
			<ScrollToTop>
				<Switch>
					{ Routes }
				</Switch>
			</ScrollToTop>
		</BrowserRouter>
	)
}

export default withAuthentication(App)



// WEBPACK FOOTER //
// ./src/app.js